<template>
  <div class="calculator-selector">
    <div class="title">
      {{ $t('calculators') }}
    </div>
    <div class="items-container">
      <div class="list">
        <span :class="{ 'active': currentCalculator == 'price' }" @click="setCurrentCalculator('price')">
          {{ $t('amd_price') }}
        </span>
        <span :class="{ 'active': currentCalculator == 'profit' }" @click="setCurrentCalculator('profit')">
          {{ $t('profit_level') }}
        </span>
      </div>
      <div class="locale-changer-container">
        <LocaleChanger/>
      </div>
    </div>
  </div>
  <Wrapper
    :currentCalculator="currentCalculator"
    :title="string('title')"
    :bottomTitle="string('bottom_title')"
    />
</template>

<script>
import LocaleChanger from './components/LocaleChanger.vue'
import Wrapper from './components/Wrapper.vue'

export default {
  components: {
    LocaleChanger,
    Wrapper,
  },
  data() {
    return {
      currentCalculator: 'price',
    }
  },
  methods: {
    string(id) {
      return this.$t(`${this.currentCalculator}_${id}`)
    },
    setCurrentCalculator(id, updateHash=true) {
      this.currentCalculator = id
      if(updateHash) {
        window.location.hash = `#id=${id}`
      }
    },
  },
  mounted() {
    const m = window.location.hash.match(/id=(.+)/)
    if(m) {
      this.setCurrentCalculator(m[1], false)
    }

  },
}
</script>

<style scoped>
.calculator-selector {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 12px 16px;
  border: 1px solid #dee2e6;
  font-size: 0.9rem;
}
.calculator-selector .title {
  /* Hide on mobile */
  display: none;
}
.calculator-selector .list span {
  cursor: pointer;
  margin-left: 12px;
  opacity: 0.5;
}
.calculator-selector .list span.active {
  opacity: 1;
}
.calculator-selector .items-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.locale-changer-container {
  margin-left: 16px;
}
@media screen and (min-width: 480px) {
  .calculator-selector .title {
    display: block;
  }
  .calculator-selector {
    justify-content: space-between;
    font-size: 1rem;
    padding: 16px 32px;
  }
  .calculator-selector .list span {
    margin-left: 16px;
  }
}
</style>